<script setup lang="ts">
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { DetailsCarItemData } from '@autobid/ui/types/Car'
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

const props = defineProps<{
  car: DetailsCarItemData | PreviewItemData
  details: DetailsCarItemDetails
}>()
const { demurageeFee, generalInformation, goft } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div>
    <table class="border-collapse text-lg leading-snug" style="color: #58585a">
      <tr>
        <td class="px-7">
          <table>
            <SectionsDetailsPdfSectionsInformation
              :information="details.information"
              :gallery="details.gallery"
            />
            <SectionsDetailsPdfSectionsAdditionalInfo :car="car" />
            <SectionsDetailsPdfSectionsDocuments :details="details" />
            <SectionsDetailsPdfSectionsAccidentPredamages :details="details" />
            <SectionsDetailsPdfSectionsEngineTransmissionTurbo
              :details="details"
            />
            <SectionsDetailsPdfSectionsExtras :details="details" />
            <SectionsDetailsPdfElementsTitleWithContent :data="goft" />
            <SectionsDetailsPdfElementsTitleWithContent :data="demurageeFee" />
            <SectionsDetailsPdfSectionsSpecialExtras :details="details" />
            <SectionsDetailsPdfSectionsSeats :details="details" />
            <SectionsDetailsPdfElementsTitleWithContent
              :data="generalInformation"
            />
            <SectionsDetailsPdfSectionsAccidentInfo :details="details" />
            <SectionsDetailsPdfSectionsImagePanelInstrument
              :details="details"
            />
            <SectionsDetailsPdfSectionsImageAdditionalDetails
              :details="details"
            />
            <SectionsDetailsPdfSectionsImageBeautyDetails :details="details" />
            <SectionsDetailsPdfSectionsWheels
              :wheels="details.wheels"
              :title="$t('car-details.section.wheels')"
            />
            <SectionsDetailsPdfSectionsWheels
              :wheels="details.secondWheels"
              :title="$t('car-details.section.second-wheels')"
            />
            <SectionsDetailsPdfSectionsPart
              :part="details.imagesExterior"
              part-name="exterior"
            />
            <SectionsDetailsPdfSectionsPart
              :part="details.imagesInterior"
              part-name="interior"
            />
            <SectionsDetailsPdfSectionsPart
              :part="details.imagesWindshield"
              part-name="windshield"
            />
            <SectionsDetailsPdfSectionsFoundDefects :details="details" />
            <SectionsDetailsPdfSectionsMissingParts :details="details" />
            <SectionsDetailsPdfSectionsManufacturerInformation
              :details="details"
            />
            <SectionsDetailsPdfSectionsGallery :images="details.gallery" />
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>
